/* eslint-disable no-param-reassign */
import Fetch, { V1, V2, V3 } from 'Util/fetcher';

import Compressor from 'compressorjs';

const QUALITY = 0.1;
const CONVERT_SIZE = 5000000;

const CompressImg = file => new Promise((resolve, reject) => {
    // eslint-disable-next-line no-new
    new Compressor(file, {
        quality: QUALITY,
        convertSize: CONVERT_SIZE,
        success: resolve,
        error: reject,
    });
});

const ON_REQUEST_CONFIRMED_TRANSACTION_MF = 'ON_REQUEST_CONFIRMED_TRANSACTION_MF';
const ON_REQUEST_CONFIRMED_TRANSACTION_MF_SUCCESS = 'ON_REQUEST_CONFIRMED_TRANSACTION_MF_SUCCESS';
const ON_REQUEST_CONFIRMED_TRANSACTION_MF_FAILURE = 'ON_REQUEST_CONFIRMED_TRANSACTION_MF_FAILURE';

function onRequestConfirmedTransactionMF(resetData) {
  return {
    type: ON_REQUEST_CONFIRMED_TRANSACTION_MF,
    meta: { resetData }
  };
}

function onRequestConfirmedTransactionMFSuccess(payload) {
  return {
    type: ON_REQUEST_CONFIRMED_TRANSACTION_MF_SUCCESS,
    payload,
  };
}

function onRequestConfirmedTransactionMFFailure(payload) {
  return {
    type: ON_REQUEST_CONFIRMED_TRANSACTION_MF_FAILURE,
    payload,
  };
}

export const onDoRequestConfirmedTransactionMF = (payload, resetData = false) => (dispatch) => {
  dispatch(onRequestConfirmedTransactionMF(resetData));
  Fetch.get(`${V1}mutualfund/transactions/order/confirmed/${payload}`).then((resp) => {
    if (resp.ok) {
        dispatch(onRequestConfirmedTransactionMFSuccess(resp.json));
      } else {
        dispatch(onRequestConfirmedTransactionMFFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestConfirmedTransactionMFFailure(error.message));
    });
};

const ON_REQUEST_PROGRESS_TRANSACTION_MF = 'ON_REQUEST_PROGRESS_TRANSACTION_MF';
const ON_REQUEST_PROGRESS_TRANSACTION_MF_SUCCESS = 'ON_REQUEST_PROGRESS_TRANSACTION_MF_SUCCESS';
const ON_REQUEST_PROGRESS_TRANSACTION_MF_FAILURE = 'ON_REQUEST_PROGRESS_TRANSACTION_MF_FAILURE';


function onRequestProgressTransactionMF(resetData) {
  return {
    type: ON_REQUEST_PROGRESS_TRANSACTION_MF,
    meta: { resetData }
  };
}

function onRequestProgressTransactionMFSuccess(payload) {
  return {
    type: ON_REQUEST_PROGRESS_TRANSACTION_MF_SUCCESS,
    payload,
  };
}

function onRequestProgressTransactionMFFailure(payload) {
  return {
    type: ON_REQUEST_PROGRESS_TRANSACTION_MF_FAILURE,
    payload,
  };
}

export const onDoRequestProgressTransactionMF = (payload, resetData = false) => (dispatch) => {
  dispatch(onRequestProgressTransactionMF(resetData));
  Fetch.get(`${V1}mutualfund/transactions/order/in-progress${payload}`).then((resp) => {
      if (resp.ok) {
        dispatch(onRequestProgressTransactionMFSuccess(resp.json));
      } else {
        dispatch(onRequestProgressTransactionMFFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestProgressTransactionMFFailure(error.message));
    });
};

const ON_REQUEST_DETAIL_TRANSACTION_MF = 'ON_REQUEST_DETAIL_TRANSACTION_MF';
const ON_REQUEST_DETAIL_TRANSACTION_MF_SUCCESS = 'ON_REQUEST_DETAIL_TRANSACTION_MF_SUCCESS';
const ON_REQUEST_DETAIL_TRANSACTION_MF_FAILURE = 'ON_REQUEST_DETAIL_TRANSACTION_MF_FAILURE';

function onRequestDetailMFTransaction() {
  return {
    type: ON_REQUEST_DETAIL_TRANSACTION_MF,
  };
}

function onRequestDetailMFTransactionSuccess(payload) {
  return {
    type: ON_REQUEST_DETAIL_TRANSACTION_MF_SUCCESS,
    payload,
  };
}

function onRequestDetailMFTransactionFailure(payload) {
  return {
    type: ON_REQUEST_DETAIL_TRANSACTION_MF_FAILURE,
    payload,
  };
}

export const onDoRequestDetailDeposit = payload => (dispatch) => {
  dispatch(onRequestDetailMFTransaction());
    Fetch.get(`${V2}transactions/deposits/${payload}/`).then((resp) => { 
      if (resp.ok) {
        dispatch(onRequestDetailMFTransactionSuccess(resp.json));
      } else {
        dispatch(onRequestDetailMFTransactionFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestDetailMFTransactionFailure(error.message));
    });
};

export const onDoRequestDetailWithdraw = payload => (dispatch) => {
  dispatch(onRequestDetailMFTransaction());
    Fetch.get(`${V2}transactions/withdrawals/${payload}/`).then((resp) => { 
      if (resp.ok) {
        dispatch(onRequestDetailMFTransactionSuccess(resp.json));
      } else {
        dispatch(onRequestDetailMFTransactionFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestDetailMFTransactionFailure(error.message));
    });
};


const ON_REQUEST_TRANSACTION_DETAIL_VA = 'ON_REQUEST_TRANSACTION_DETAIL_VA';
const ON_REQUEST_TRANSACTION_DETAIL_VA_SUCCESS = 'ON_REQUEST_TRANSACTION_DETAIL_VA_SUCCESS';
const ON_REQUEST_TRANSACTION_DETAIL_VA_FAILURE = 'ON_REQUEST_TRANSACTION_DETAIL_VA_FAILURE';

function onRequestTransactionDetailVA() {
  return {
    type: ON_REQUEST_TRANSACTION_DETAIL_VA,
  };
}

function onRequestTransactionDetailVASuccess(payload) {
  return {
    type: ON_REQUEST_TRANSACTION_DETAIL_VA_SUCCESS,
    payload,
  };
}

function onRequestTransactionDetailVAFailure(payload) {
  return {
    type: ON_REQUEST_TRANSACTION_DETAIL_VA_FAILURE,
    payload,
  };
}

export const onDoResetTransactionDetailVA = () => (dispatch) => {
  dispatch(onRequestTransactionDetailVASuccess(null));
};

export const onDoRequestTransactionDetailVA = payload => (dispatch) => {
  dispatch(onRequestTransactionDetailVA());
    Fetch.get(`${V1}transactions/detail/${payload}/`).then((resp) => { 
      if (resp.ok) {
        dispatch(onRequestTransactionDetailVASuccess(resp.json));
      } else {
        dispatch(onRequestTransactionDetailVAFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestTransactionDetailVAFailure(error.message));
    });
};

const ON_UPLOADED_PAYMENT_PROOF = 'ON_UPLOADED_PAYMENT_PROOF';
const ON_UPLOADED_PAYMENT_PROOF_SUCCESS = 'ON_UPLOADED_PAYMENT_PROOF_SUCCESS';
const ON_UPLOADED_PAYMENT_PROOF_FAILURE = 'ON_UPLOADED_PAYMENT_PROOF_FAILURE';

function onUploadedPaymentProof() {
  return {
    type: ON_UPLOADED_PAYMENT_PROOF
  };
}

function onUploadedPaymentProofSuccess() {
  return {
    type: ON_UPLOADED_PAYMENT_PROOF_SUCCESS,
  };
}

function onUploadedPaymentProofError(payload) {
  return {
    type: ON_UPLOADED_PAYMENT_PROOF_SUCCESS,
    payload
  };
}

export const onDoSubmittedPaymentProof = payload => (dispatch) => {
  const proofImg = payload.proof[0];
  CompressImg(proofImg).then((response) => {
      const reader = new FileReader();
      reader.readAsDataURL(response); 
      reader.onloadend = () => {    
        const proof = {
            proof: reader.result
        };
        dispatch(onUploadedPaymentProof());
        Fetch.post(`${V3}transactions/deposits/${payload.id}/verify/`, proof).then((resp) => {
            if (resp.ok) {
                dispatch(onUploadedPaymentProofSuccess());
            } else {
                dispatch(onUploadedPaymentProofError(resp.json.proof[0]));
            }
        }).catch((err) => {
            dispatch(onUploadedPaymentProofError(err.message));
        });
      };
      reader.onerror = (err) => {
        dispatch(onUploadedPaymentProofError(err.message));
        reader.abort();
      };
  }).catch((err) => {
    dispatch(onUploadedPaymentProofError(err.message));
  });
};

const ON_REQUEST_CANCEL_DEPOSIT = 'ON_REQUEST_CANCEL_DEPOSIT';
const ON_REQUEST_CANCEL_DEPOSIT_SUCCESS = 'ON_REQUEST_CANCEL_DEPOSIT';
const ON_REQUEST_CANCEL_DEPOSIT_FAILURE = 'ON_REQUEST_CANCEL_DEPOSIT';

function onRequestCancelDeposit() {
  return {
      type: ON_REQUEST_CANCEL_DEPOSIT,
  };
}

function onRequestCancelDepositSuccess(payload) {
  return {
      type: ON_REQUEST_CANCEL_DEPOSIT_SUCCESS,
      payload
  };
}

function onRequestCancelDepositFailure(payload) {
  return {
      type: ON_REQUEST_CANCEL_DEPOSIT_FAILURE,
      payload
  };
}

export const onCancelDeposit = payload => (dispatch) => {
  dispatch(onRequestCancelDeposit());
      Fetch.post(`${V1}transactions/orders/${payload}/cancel/`).then((resp) => { 
          if (resp.ok) {
              dispatch(onRequestCancelDepositSuccess(resp.json));
          } else {
              dispatch(onRequestCancelDepositFailure(resp.json));
          }
  }).catch((error) => {
      dispatch(onRequestCancelDepositFailure(error.message));
  });
};

const ON_REQUEST_CANCEL_WITHDRAWAL = 'ON_REQUEST_CANCEL_WITHDRAWAL';
const ON_REQUEST_CANCEL_WITHDRAWAL_SUCCESS = 'ON_REQUEST_CANCEL_WITHDRAWAL_SUCCESS';
const ON_REQUEST_CANCEL_WITHDRAWAL_FAILURE = 'ON_REQUEST_CANCEL_WITHDRAWAL_FAILURE';


function onRequestCancelWithdrawal() {
  return {
      type: ON_REQUEST_CANCEL_WITHDRAWAL,
  };
}

function onRequestCancelWithdrawalSuccess(payload) {
  return {
      type: ON_REQUEST_CANCEL_WITHDRAWAL_SUCCESS,
      payload
  };
}

function onRequestCancelWithdrawalFailure(payload) {
  return {
      type: ON_REQUEST_CANCEL_WITHDRAWAL_FAILURE,
      payload
  };
}

export const onCancelWithdrawal = payload => (dispatch) => {
  dispatch(onRequestCancelWithdrawal());
      Fetch.post(`${V1}transactions/withdrawals/${payload}/cancel/`).then((resp) => { 
          if (resp.ok) {
              dispatch(onRequestCancelWithdrawalSuccess(resp.json));
          } else {
              dispatch(onRequestCancelWithdrawalFailure(resp.json));
          }
  }).catch((error) => {
      dispatch(onRequestCancelWithdrawalFailure(error.message));
  });
};

const ON_REQUEST_AUTO_TRANSACTION_MF = 'ON_REQUEST_AUTO_TRANSACTION_MF';
const ON_REQUEST_AUTO_TRANSACTION_MF_SUCCESS = 'ON_REQUEST_AUTO_TRANSACTION_MF_SUCCESS';
const ON_REQUEST_AUTO_TRANSACTION_MF_FAILURE = 'ON_REQUEST_AUTO_TRANSACTION_MF_FAILURE';

function onRequestAutoTransactionMF(resetData) {
  return {
    type: ON_REQUEST_AUTO_TRANSACTION_MF,
    meta: { resetData }
  };
}

function onRequestAutoTransactionMFSuccess(payload) {
  return {
    type: ON_REQUEST_AUTO_TRANSACTION_MF_SUCCESS,
    payload,
  };
}

function onRequestAutoTransactionMFFailure(payload) {
  return {
    type: ON_REQUEST_AUTO_TRANSACTION_MF_FAILURE,
    payload,
  };
}

export const onDoRequestAutoTransactionMF = (payload, resetData = false) => (dispatch) => {
  dispatch(onRequestAutoTransactionMF(resetData));
  Fetch.get(`${V3}mutualfund/auto-order${payload}`).then((resp) => {
    if (resp.ok) {
        dispatch(onRequestAutoTransactionMFSuccess(resp.json));
      } else {
        dispatch(onRequestAutoTransactionMFFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestAutoTransactionMFFailure(error.message));
    });
};


const ON_REQUEST_DETAIL_AUTO_MF = 'ON_REQUEST_DETAIL_AUTO_MF';
const ON_REQUEST_DETAIL_AUTO_MF_SUCCESS = 'ON_REQUEST_DETAIL_AUTO_MF_SUCCESS';
const ON_REQUEST_DETAIL_AUTO_MF_FAILURE = 'ON_REQUEST_DETAIL_AUTO_MF_FAILURE';

function onRequestDetailAutoOrder() {
  return {
    type: ON_REQUEST_DETAIL_AUTO_MF,
  };
}

function onRequestDetailAutoOrderSuccess(payload) {
  return {
    type: ON_REQUEST_DETAIL_AUTO_MF_SUCCESS,
    payload,
  };
}

function onRequestDetailAutoOrderFailure(payload) {
  return {
    type: ON_REQUEST_DETAIL_AUTO_MF_FAILURE,
    payload,
  };
}

export const onDoRequestDetailAutoOrder = payload => (dispatch) => {
  dispatch(onRequestDetailAutoOrder());
    Fetch.get(`${V3}mutualfund/auto-order/${payload}/`).then((resp) => { 
      if (resp.ok) {
        dispatch(onRequestDetailAutoOrderSuccess(resp.json));
      } else {
        dispatch(onRequestDetailAutoOrderFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestDetailAutoOrderFailure(error.message));
    });
};

const INITIAL_STATE = {
  progressTransactionMFLoading: null,
  progressTransactionMFError: null,
  progressTransactionMFData: null,

  confirmedTransactionMFLoading: null,
  confirmedTransactionMFError: null,
  confirmedTransactionMFData: null,

  detailTransactionMFLoading: null,
  detailTransactionMFData: null,
  detailTransactionMFError: null,

  onUploaded: null,
  onUploadedError: null,
  onUploadedSuccess: false,

  transactionDetailVALoading: null,
  transactionDetailVAData: null,
  transactionDetailVAError: null,

  cancelDeposit: null,
  cancelDepositLoading: false,
  cancelDepositError: null,

  cancelWithdrawal: null,
  cancelWithdrawalLoading: false,
  cancelWithdrawalError: null,

  autoTransactionMFLoading: null,
  autoTransactionMFError: null,
  autoTransactionMFData: null,

  detailAutoMFLoading: null,
  detailAutoMFData: null,
  detailAutoMFError: null,
};
const mfTransaction = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ON_REQUEST_DETAIL_TRANSACTION_MF:
      return {
        ...state,
        detailTransactionMFLoading: true,
        detailTransactionMFData: null,
        detailTransactionMFError: null
      };
    case ON_REQUEST_DETAIL_TRANSACTION_MF_SUCCESS:
      return {
        ...state,
        detailTransactionMFLoading: false,
        detailTransactionMFData: action.payload,
        detailTransactionMFError: null,
      };
    case ON_REQUEST_DETAIL_TRANSACTION_MF_FAILURE:
      return {
        ...state,
        detailTransactionMFLoading: false,
        detailTransactionMFData: null,
        detailTransactionMFError: action.payload,
      };

    case ON_UPLOADED_PAYMENT_PROOF:
      return {
          ...state,
          onUploaded: true,
          onUploadedError: null,
          onUploadedSuccess: false
      };
    case ON_UPLOADED_PAYMENT_PROOF_FAILURE:
        return {
            ...state,
            onUploaded: false,
            onUploadedError: action.payload,
            onUploadedSuccess: false
        };
    case ON_UPLOADED_PAYMENT_PROOF_SUCCESS:
        return {
            ...state,
            onUploaded: false,
            onUploadedError: null,
            onUploadedSuccess: true
        };

      case ON_REQUEST_TRANSACTION_DETAIL_VA:
        return {
            ...state,
            transactionDetailVALoading: true,
            // transactionDetailVAData: null,
            transactionDetailVAError: null
        };
    case ON_REQUEST_TRANSACTION_DETAIL_VA_SUCCESS:
        return {
            ...state,
            transactionDetailVALoading: false,
            transactionDetailVAData: { ...action.payload },
            transactionDetailVAError: null,
        };
    case ON_REQUEST_TRANSACTION_DETAIL_VA_FAILURE:
        return {
            ...state,
            transactionDetailVALoading: false,
            transactionDetailVAData: null,
            transactionDetailVAError: action.payload,
        };

    case ON_REQUEST_CANCEL_WITHDRAWAL:
      return {
        ...state,
        cancelWithdrawalLoading: true,
        cancelWithdrawal: null,
        cancelWithdrawalError: null
      };
    case ON_REQUEST_CANCEL_WITHDRAWAL_SUCCESS:
        return {
          ...state,
          cancelWithdrawalLoading: false,
          cancelWithdrawal: action.payload,
          cancelWithdrawalError: null
        };
    case ON_REQUEST_CANCEL_WITHDRAWAL_FAILURE:
        return {
          ...state,
          cancelWithdrawalLoading: false,
          cancelWithdrawal: null,
          cancelWithdrawalError: action.payload
        };

    case ON_REQUEST_CANCEL_DEPOSIT:
        return {
          ...state,
          cancelDepositLoading: true,
          cancelDeposit: null,
          cancelDepositError: null
        };
    case ON_REQUEST_CANCEL_DEPOSIT_SUCCESS:
        return {
            ...state,
            cancelDepositLoading: false,
            cancelDeposit: action.payload,
            cancelDepositError: null
        };
    case ON_REQUEST_CANCEL_DEPOSIT_FAILURE:
        return {
            ...state,
            cancelDepositLoading: false,
            cancelDeposit: null,
            cancelDepositError: action.payload
        };

      case ON_REQUEST_PROGRESS_TRANSACTION_MF:
      if (action.meta.resetData) {
        return {
          ...state,
          progressTransactionMFLoading: true,
          progressTransactionMFData: null,
          progressTransactionMFError: null
        };
      } 
        return {
          ...state,
          progressTransactionMFLoading: true,
          progressTransactionMFError: null
        };
      
    case ON_REQUEST_PROGRESS_TRANSACTION_MF_SUCCESS:
      if (state.progressTransactionMFData) {
        const oldResults = [...state.progressTransactionMFData.results];
        state.progressTransactionMFData = {
          ...action.payload,
          results: [
            ...oldResults,
            ...action.payload.results
          ]
        };
      } else {
        state.progressTransactionMFData = action.payload;
      }
      return {
        ...state,
        progressTransactionMFLoading: false,
        progressTransactionMFError: null
      };
    case ON_REQUEST_PROGRESS_TRANSACTION_MF_FAILURE:
      return {
        ...state,
        progressTransactionMFLoading: false,
        progressTransactionMFError: action.payload
      };
    
    case ON_REQUEST_CONFIRMED_TRANSACTION_MF:
      if (action.meta.resetData) {
        return {
          ...state,
          confirmedTransactionMFLoading: true,
          confirmedTransactionMFData: null,
          confirmedTransactionMFError: null
        };
      } 
        return {
          ...state,
          confirmedTransactionMFLoading: true,
          confirmedTransactionMFError: null
        };
      
    case ON_REQUEST_CONFIRMED_TRANSACTION_MF_SUCCESS:
      if (state.confirmedTransactionMFData) {
        const oldResults = [...state.confirmedTransactionMFData.results];
        state.confirmedTransactionMFData = {
          ...action.payload,
          results: [
            ...oldResults,
            ...action.payload.results
          ]
        };
      } else {
        state.confirmedTransactionMFData = action.payload;
      }
      return {
        ...state,
        confirmedTransactionMFLoading: false,
        confirmedTransactionMFError: null
      };
    case ON_REQUEST_CONFIRMED_TRANSACTION_MF_FAILURE:
      return {
        ...state,
        confirmedTransactionMFLoading: false,
        confirmedTransactionMFError: action.payload
    };
    case ON_REQUEST_AUTO_TRANSACTION_MF:
      if (action.meta.resetData) {
        return {
          ...state,
          autoTransactionMFLoading: true,
          autoTransactionMFData: null,
          autoTransactionMFError: null
        };
      } 
        return {
          ...state,
          autoTransactionMFLoading: true,
          autoTransactionMFError: null
        };
      
    case ON_REQUEST_AUTO_TRANSACTION_MF_SUCCESS:
      if (state.autoTransactionMFData) {
        const oldResults = [...state.autoTransactionMFData.results];
        state.autoTransactionMFData = {
          ...action.payload,
          results: action.payload.results
        };
      } else {
        state.autoTransactionMFData = action.payload;
      }
      return {
        ...state,
        autoTransactionMFLoading: false,
        autoTransactionMFError: null
      };
    case ON_REQUEST_AUTO_TRANSACTION_MF_FAILURE:
      return {
        ...state,
        autoTransactionMFLoading: false,
        autoTransactionMFError: action.payload
    };

    case ON_REQUEST_DETAIL_AUTO_MF:
        return {
            ...state,
            detailAutoMFLoading: true,
            detailAutoMFData: null,
            detailAutoMFError: null
        };
    case ON_REQUEST_DETAIL_AUTO_MF_SUCCESS:
        return {
            ...state,
            detailAutoMFLoading: false,
            detailAutoMFData: { ...action.payload },
            detailAutoMFError: null,
        };
    case ON_REQUEST_DETAIL_AUTO_MF_FAILURE:
        return {
            ...state,
            detailAutoMFLoading: false,
            detailAutoMFData: null,
            detailAutoMFError: action.payload,
        };


    default:
      return state;
  }
};
export default mfTransaction;
